import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface Props {
    onConfirm: () => void;
    title: string;
    description: React.ReactElement<any, string | React.JSXElementConstructor<any>> | null | undefined;
}

const ConfirmationModal: React.FC<Props> = ({ onConfirm, title, description }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const dispatch = useDispatch();

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.CONFIRMATION_MODAL));
    };

    const handleSubmit = () => {
        onConfirm();
        dismissModalHandler();
    };

    return (
        <>
            <div className="confirm-content">
                <Modal.Header>
                    <div className="header-info">
                        <Modal.Title>
                            <span className="title">{title}</span>
                        </Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-description">{description}</div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="btn-container">
                        <button className="btn btn-block modal-btn btn-cancel" data-dismiss="modal" onClick={dismissModalHandler} type="button">
                            {strings.NO}
                        </button>
                        <button className="btn btn-primary btn-block modal-btn" data-dismiss="modal" onClick={handleSubmit} type="button">
                            {strings.YES}
                        </button>
                    </div>
                </Modal.Footer>
            </div>
        </>
    );
};

export default ConfirmationModal;
